// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"157":"9756b027","254":"0877936a"}[chunkId] + ".chunk.css";
};